import { useState } from 'react';
import { pathgen } from 'object-path-generator';
import { Column, ConfirmationModal, RichTextEditor, TextField, Typography } from 'seagull';
import styles from "./ServiceItem.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EditServiceContentTestIds = pathgen('EditServiceContentTestIds');
const EditServiceContent = _ref => {
  let {
    includedService,
    dismissModal,
    onSave
  } = _ref;
  const [serviceName, setServiceName] = useState(includedService.name);
  const [serviceDescription, setServiceDescription] = useState(includedService.description);
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    "data-testid": EditServiceContentTestIds.EditServiceModal(),
    title: "Edit Included Service",
    content: /*#__PURE__*/_jsxs(Column, {
      className: styles.modalContent,
      children: [/*#__PURE__*/_jsx(TextField, {
        type: "text",
        id: "serviceName",
        name: "serviceName",
        label: "Service Name",
        value: serviceName,
        onChange: e => {
          setServiceName(e.target.value);
        },
        "data-testid": EditServiceContentTestIds.EditServiceNameInput()
      }), /*#__PURE__*/_jsxs(Column, {
        className: styles.serviceDescriptionWrapper,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "secondary",
          children: "Service description"
        }), /*#__PURE__*/_jsx(RichTextEditor, {
          className: styles.serviceDescription,
          editorHeight: 310,
          placeholder: "Describe service (Optional)",
          "data-testid": EditServiceContentTestIds.EditServiceDescriptionInput(),
          initialValue: serviceDescription,
          onChange: v => {
            setServiceDescription(JSON.stringify(v));
          }
        })]
      })]
    }),
    onPrimaryButtonClick: () => onSave({
      name: serviceName,
      description: serviceDescription
    }),
    onSecondaryButtonClick: () => dismissModal(),
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    primaryButtonTestid: EditServiceContentTestIds.EditServiceModalSaveButton()
  });
};
export default EditServiceContent;